/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/23/20
 *
 */
import BaseObject from "@shared/BaseObject.js";
import DriveStorageFeature from "@shared/Subscription/Features/DriveStorageFeature";
import {Type} from "class-transformer"
import {ValuesEnum} from "@shared/Subscription/ValuesEnum.js";

export default class SubscriptionFeatures extends BaseObject {

	activeClientLimit = ValuesEnum.NO_LIMIT
	groupLimit = ValuesEnum.NO_LIMIT
	teamMembersLimit = ValuesEnum.NO_LIMIT
	maxStorageSize =  ValuesEnum.SIZE_1GB

	prospectDetailsDisabled = false

	//deprecated. Use maxStorageSize
	@Type(() => DriveStorageFeature)
	driveStorageFeature: DriveStorageFeature = new DriveStorageFeature()


	constructor(settings = {}) {
		super();
		Object.assign(this, settings);
	}
}
